'use client'

import React, { useEffect, useState } from 'react'
import Script from 'next/script'

// DEFERRED THIRD-PARTY TAG LOADER — GTM ONLY.
//
// 2026-08-05: reduced from a stack of hardcoded loaders (Meta Pixel bootstrap,
// GA4 gtag.js for both properties, Clarity, Google Ads) to JUST the GTM
// container. Jahangir's server-side GTM setup (client GTM-MXV5XMP4 + server
// GTM-ND73BRX5) fires all the underlying tags:
//   - GA4 both properties (G-SNHMLWLEJB, G-TV8EK75DN0)
//   - Meta Pixel + CAPI (deduped by event_id via sGTM)
//   - Google Ads (AW-16466469028) conversions + remarketing + Enhanced Conversions
//   - Microsoft Clarity (m8u9ilvb4r) with consent gating
// So the previous hardcoded loaders were duplicating what GTM already does; each
// duplicate risked double-counting where dedup keys mismatch (see Meta browser vs
// CAPI event_id, or GA4 non-purchase events).
//
// GTM itself is still deferred: the container is heavy enough to steal ~200-800ms
// of main-thread on cold visits, and none of it is needed before first paint.
// Load on the FIRST of: a real user interaction (pointer / key / touch / scroll)
// OR a ~4s idle timeout so a bounced visitor is still counted.
//
// SAFETY: Consent Mode v2 defaults + the immediate stored-consent update run
// beforeInteractive in app/layout.js — GTM tags see the correct consent state
// the moment the container loads. GA/GTM queue events on window.dataLayer so
// deferring the container never drops events — AppRouterPageView's page_view
// pushes flush when GTM initializes.
const IDLE_MS = 4000

export default function DeferredThirdParty() {
  const [armed, setArmed] = useState(false)

  useEffect(() => {
    if (armed) return
    let done = false
    const events = ['pointerdown', 'keydown', 'touchstart', 'scroll']
    const opts = { passive: true }
    const cleanup = () => {
      clearTimeout(timer)
      events.forEach((e) => window.removeEventListener(e, fire, opts))
    }
    const fire = () => {
      if (done) return
      done = true
      cleanup()
      setArmed(true)
    }
    events.forEach((e) => window.addEventListener(e, fire, opts))
    const timer = setTimeout(fire, IDLE_MS)
    return cleanup
  }, [armed])

  if (!armed) return null

  return (
    <>
      {/* Stape Custom Loader + Cookie Keeper (2026-07-28 tracking, Jahangir).
          Serves the GTM script from our own first-party subdomain
          (ss.vrs.racing / load.ss.vrs.racing) instead of googletagmanager.com,
          which bypasses ad blockers that block google/gtm domains. The
          "Cookie Keeper" branch (Safari 16.4+) reads the stapeUserId cookie
          and appends it as a bootstrap identity (?bi=), so first-party
          cookies set by server-side GTM survive Safari ITP + iOS Link
          Tracking. Replaces the plain googletagmanager.com/gtm.js inline
          snippet the site used before; container ID (GTM-MXV5XMP4) is
          unchanged, so all existing tags/triggers keep firing identically. */}
      {/* Stape Custom Loader + Cookie Keeper.
          Serves the GTM container from our first-party subdomain
          (ss.vrs.racing / load.ss.vrs.racing) instead of googletagmanager.com,
          bypassing ad blockers of the google/gtm domains. The Cookie Keeper
          branch (Safari 16.4+) reads the stapeUserId cookie and appends it as
          a bootstrap identity so first-party cookies set by server-side GTM
          survive Safari ITP + iOS Link Tracking. Container ID GTM-MXV5XMP4. */}
      <Script
        id="gtm"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `!function(){"use strict";function l(e){for(var t=e,r=0,n=document.cookie.split(";");r<n.length;r++){var o=n[r].split("=");if(o[0].trim()===t)return o[1]}}function s(e){return localStorage.getItem(e)}function u(e){return window[e]}function A(e,t){e=document.querySelector(e);return t?null==e?void 0:e.getAttribute(t):null==e?void 0:e.textContent}var e=window,t=document,r="script",n="dataLayer",o="https://ss.vrs.racing",a="https://load.ss.vrs.racing",i="aqpafxwhs",c="n=GgxKPzIsXTwrPkIgKzFEVwVVRVZXRxQfTh4FC0gTERIaBhA%3D",g="stapeUserId",v="",E="",d=!1;try{var d=!!g&&(m=navigator.userAgent,!!(m=new RegExp("Version/([0-9._]+)(.*Mobile)?.*Safari.*").exec(m)))&&16.4<=parseFloat(m[1]),f="stapeUserId"===g,I=d&&!f?function(e,t,r){void 0===t&&(t="");var n={cookie:l,localStorage:s,jsVariable:u,cssSelector:A},t=Array.isArray(t)?t:[t];if(e&&n[e])for(var o=n[e],a=0,i=t;a<i.length;a++){var c=i[a],c=r?o(c,r):o(c);if(c)return c}else console.warn("invalid uid source",e)}(g,v,E):void 0;d=d&&(!!I||f)}catch(e){console.error(e)}var m=e,g=(m[n]=m[n]||[],m[n].push({"gtm.start":(new Date).getTime(),event:"gtm.js"}),t.getElementsByTagName(r)[0]),v=I?"&bi="+encodeURIComponent(I):"",E=t.createElement(r),f=(d&&(i=8<i.length?i.replace(/([a-z]{8}$)/,"kp$1"):"kp"+i),!d&&a?a:o);E.async=!0,E.src=f+"/"+i+".js?"+c+v,null!=(e=g.parentNode)&&e.insertBefore(E,g)}();`,
        }}
      />
    </>
  )
}
